import styled from "styled-components";
import InputWithModalClick from "./components/InputWithModalClick";
import { ChangeEvent, useEffect, useRef, useState } from "react";
import { media } from "../media";
import { useAuth } from "../hooks/useAuth";
import CardBone from "./components/CardBone";
import { useAlbum } from "../hooks/useAlbum";
import CardList from "./components/CardList";

interface IsPlay {
  handlePrev: () => void;
}

const Play = ({ handlePrev }: IsPlay) => {
  const isDesktop = window.innerWidth > 767;
  const { getCurrentDocs, currentDocs, searchByVocal, getVocalList } =
    useAlbum();
  const [input, setInput] = useState("");

  const { user } = useAuth();

  const onChangeInput = (e: ChangeEvent<HTMLInputElement>) => {
    setInput(e.target.value);
  };
  const onSelectValue = (value: string) => {
    searchByVocal(value);
    setInput(() => "");
    scrollToTop();
  };

  const onDelSearchValue = async () => {
    getCurrentDocs();
  };

  const CardWrapRef = useRef<HTMLDivElement>(null);
  const scrollToTop = () => {
    CardWrapRef.current?.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    scrollToTop();
  }, [currentDocs]);

  // useEffect(() => {
  //   if (!input) return;
  //   const debounce = setTimeout(() => {
  //     console.log(input);
  //     return searchByVocal(input);
  //   }, 2000);
  //   return () => clearTimeout(debounce);
  // }, [input]);

  return (
    <PlayWrap>
      <div className="Header">
        {!isDesktop && (
          <div className="LeftBtn" onClick={handlePrev}>
            <svg
              width="17"
              height="17"
              viewBox="0 0 17 17"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <mask id="path-1-inside-1_526_247" fill="white">
                <path d="M16.9707 8.48535L8.48542 16.9706L0.000140667 8.48535L8.48542 7.03335e-05L16.9707 8.48535Z" />
              </mask>
              <path
                d="M0.000140667 8.48535L-0.706966 7.77824L-1.41407 8.48535L-0.706966 9.19246L0.000140667 8.48535ZM9.19253 16.2635L0.707247 7.77824L-0.706966 9.19246L7.77832 17.6777L9.19253 16.2635ZM0.707247 9.19246L9.19253 0.707177L7.77832 -0.707036L-0.706966 7.77824L0.707247 9.19246Z"
                fill="#314AF3"
                mask="url(#path-1-inside-1_526_247)"
              />
            </svg>
          </div>
        )}
        <div className="InputWrap">
          <InputWithModalClick
            name="search"
            value={input}
            onChange={onChangeInput}
            onSelectValue={onSelectValue}
            onResetInput={onDelSearchValue}
            vocalList={getVocalList()}
          />
        </div>
      </div>

      <div className="CardWrap" ref={CardWrapRef}>
        {currentDocs ? (
          <CardList
            currentDocs={currentDocs}
            currentUid={user.uid}
            handlePrev={handlePrev}
          />
        ) : (
          <>
            <CardBone />
            <CardBone />
            <CardBone />
          </>
        )}
      </div>
    </PlayWrap>
  );
};

export default Play;

const PlayWrap = styled.div`
  position: relative;
  height: 100%;
  overflow-y: auto;
  ${media.desktop`
    border-left: 1px solid #314af3; 
  `}
  .Header {
    position: fixed;
    z-index: 1000;
    background-color: white;
    width: 100%;
    height: 70px;
    padding: 0px 36px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    .InputWrap {
      width: 300px;
      padding: 0px;
    }
    .LeftBtn {
      position: absolute;
      top: 26px;
      left: 14px;
      cursor: pointer;
    }
  }
  .CardWrap {
    margin-top: 70px;
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 8px 36px 24px 36px;
  }
`;
